// src/store/slices/onlineStatusSlice.js
//
// Stores the online/offline presence state for every user the current user
// interacts with. Updated in real-time by the global SignalR handler.
//
// Shape:
//   state.onlineStatus = {
//     'user-uuid-1': true,   // online
//     'user-uuid-2': false,  // offline
//   }

import { createSlice } from '@reduxjs/toolkit';

const onlineStatusSlice = createSlice({
  name: 'onlineStatus',
  initialState: {},
  reducers: {
    /**
     * Mark one or more users as online.
     * payload: string | string[]   (userId or array of userIds)
     */
    setOnline(state, { payload }) {
      const ids = Array.isArray(payload) ? payload : [payload];
      ids.forEach((id) => { if (id) state[id] = true; });
    },

    /**
     * Mark one or more users as offline.
     * payload: string | string[]
     */
    setOffline(state, { payload }) {
      const ids = Array.isArray(payload) ? payload : [payload];
      ids.forEach((id) => { if (id) state[id] = false; });
    },

    /**
     * Bulk-set online status — used when the server sends the initial
     * online-user list on connection (e.g. a "OnlineUsers" hub event).
     * payload: string[]   (array of online userIds)
     */
    setInitialOnlineUsers(state, { payload }) {
      // First mark everyone currently tracked as offline
      Object.keys(state).forEach((id) => { state[id] = false; });
      // Then mark the provided list as online
      (payload ?? []).forEach((id) => { if (id) state[id] = true; });
    },
  },
});

export const { setOnline, setOffline, setInitialOnlineUsers } =
  onlineStatusSlice.actions;

export default onlineStatusSlice.reducer;